module.exports = __webpack_public_path__ + "static/media/paver_pink.36b37067.svg";